import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { union } from 'lodash';
import { UiState } from 'constants/ui';
import { actions as filterActions } from 'state/catalog-filters/slice';
import { initialEntityStructure } from 'libs/utils/redux';
import { ItemUiView, CATALOG_PER_PAGE, stateName } from './constants';
import { getCatalogItemsSuccess } from './actions';
export const initialState = {
  [ItemUiView.UserItems]: _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
    uiState: UiState.Idle,
    errors: null,
    currentPage: 0,
    totalPages: 0,
    totalEntries: 0,
    endReached: false
  }),
  [ItemUiView.UserBundleItems]: _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
    uiState: UiState.Idle,
    errors: null,
    currentPage: 0,
    totalPages: 0,
    totalEntries: 0,
    endReached: false,
    containsOfflineVerificationItem: false,
    offlineVerificationFee: null
  }),
  [ItemUiView.FavouriteItems]: _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
    uiState: UiState.Idle,
    errors: null,
    currentPage: 0,
    totalPages: 0,
    totalEntries: 0,
    endReached: false
  }),
  [ItemUiView.SimilarItems]: _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
    uiState: UiState.Idle,
    errors: null
  }),
  [ItemUiView.CatalogItems]: _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
    uiState: UiState.Idle,
    errors: null,
    currentPage: 0,
    totalPages: 0,
    totalEntries: 0,
    perPage: CATALOG_PER_PAGE,
    time: null,
    endReached: false
  }),
  [ItemUiView.RecommendedItems]: _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
    uiState: UiState.Idle,
    errors: null,
    currentPage: 0,
    totalPages: 0,
    totalEntries: 0,
    endReached: false
  })
};

const startLoad = view => draft => {
  draft[view].uiState = UiState.Pending;
};

const loadItems = (view, shouldReplace) => (draft, action) => {
  const {
    items,
    pagination,
    itemParamsById,
    containsOfflineVerificationItem,
    offlineVerificationFee
  } = action.payload;
  draft[view].uiState = UiState.Success;

  if (pagination) {
    draft[view].currentPage = pagination.current_page;
    draft[view].totalPages = pagination.total_pages;
    draft[view].totalEntries = pagination.total_entries;
    draft[view].perPage = pagination.per_page;
    draft[view].time = pagination.time;
    draft[view].endReached = pagination.current_page >= pagination.total_pages;
    draft[view].nextPageToken = pagination.next_page_token;
  }

  if (containsOfflineVerificationItem) {
    draft[view].containsOfflineVerificationItem = containsOfflineVerificationItem;
  }

  const newIds = [];
  items.forEach(item => {
    newIds.push(item.id);
    draft[view].byId[item.id] = item;
  });
  draft[view].searchParams = itemParamsById;
  draft[view].errors = null;
  draft[view].ids = shouldReplace ? newIds : union(draft[view].ids, newIds);
  draft[view].offlineVerificationFee = offlineVerificationFee;
};

const setItems = view => (draft, action) => {
  const {
    items
  } = action.payload;
  items.forEach(item => {
    draft[view].byId[item.id] = item;
  });
};

const loadFail = view => (draft, action) => {
  const {
    errors
  } = action.payload;
  draft[view].uiState = UiState.Failure;
  draft[view].errors = errors;
};

const resetViewState = view => draft => {
  // @ts-expect-error avoiding type narrowing
  draft[view] = initialState[view];
};

const setPage = view => (draft, action) => {
  const {
    page
  } = action.payload;
  draft[view].currentPage = page;
};

const setPerPage = view => (draft, action) => {
  const {
    perPage
  } = action.payload;
  draft[view].currentPage = 1;
  draft[view].perPage = perPage;
};

const setPagination = view => (draft, action) => {
  const {
    time,
    page,
    perPage
  } = action.payload;
  draft[view].time = time;
  draft[view].currentPage = page;
  draft[view].perPage = perPage;
};

const resetPagination = view => draft => {
  draft[view].currentPage = 1;
  draft[view].time = null;
  draft[view].perPage = CATALOG_PER_PAGE;
};

const itemSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getCatalogItemsRequest: {
      reducer: startLoad(ItemUiView.CatalogItems),
      prepare: (payload, meta) => ({
        payload,
        meta
      })
    },
    getUserItemsRequest: startLoad(ItemUiView.UserItems),
    getUserBundleItemsRequest: startLoad(ItemUiView.UserBundleItems),
    getFavouriteItemsRequest: startLoad(ItemUiView.FavouriteItems),
    getSimilarItemsRequest: startLoad(ItemUiView.SimilarItems),
    getRecommendedItemsRequest: startLoad(ItemUiView.RecommendedItems),
    getUserItemsSuccess: loadItems(ItemUiView.UserItems),
    getUserBundleItemsSuccess: loadItems(ItemUiView.UserBundleItems),
    getFavouriteItemsSuccess: loadItems(ItemUiView.FavouriteItems),
    getSimilarItemsSuccess: loadItems(ItemUiView.SimilarItems),
    getRecommendedItemsSuccess: loadItems(ItemUiView.RecommendedItems),
    getCatalogItemsFailure: loadFail(ItemUiView.CatalogItems),
    getFavouriteItemsFailure: loadFail(ItemUiView.FavouriteItems),
    getUserBundleItemsFailure: loadFail(ItemUiView.UserBundleItems),
    getUserItemsFailure: loadFail(ItemUiView.UserItems),
    getSimilarItemsFailure: loadFail(ItemUiView.SimilarItems),
    getRecommendedItemsFailure: loadFail(ItemUiView.RecommendedItems),
    resetSimilarItems: resetViewState(ItemUiView.SimilarItems),
    setCatalogItemsPage: setPage(ItemUiView.CatalogItems),
    setCatalogItemsPerPage: setPerPage(ItemUiView.CatalogItems),
    setCatalogItemsPagination: setPagination(ItemUiView.CatalogItems),
    setUserItems: setItems(ItemUiView.UserItems),
    setUserBundleItems: setItems(ItemUiView.UserBundleItems),
    setCatalogItems: setItems(ItemUiView.CatalogItems)
  },
  extraReducers: {
    [getCatalogItemsSuccess.type]: loadItems(ItemUiView.CatalogItems, true),
    [filterActions.changeFilters.type]: resetPagination(ItemUiView.CatalogItems)
  }
});
export const actions = _objectSpread(_objectSpread({}, itemSlice.actions), {}, {
  getCatalogItemsSuccess
});
export const plug = {
  [stateName]: itemSlice.reducer
};
export default itemSlice.reducer;